<app-breadcrumb></app-breadcrumb>
<div class="container">
  <app-system-wide-message></app-system-wide-message>
  <app-embedded-map></app-embedded-map>
  <div class="row">
    <div class="col-lg-6">
      <span class="badge">Details</span>
      <div class="route-label">
        <div class="route-name">
          <h2> Levittown </h2>
        </div>
        <div class="route-details">
          <a
            href="https://www.google.com/maps/dir/39.9507456,-75.1665152/Trenton+Transit+Center,+Trenton,+NJ+08609/@40.0832228,-75.2567725,10z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x89c159b651d5f3c5:0x7f6245890fa40f1f!2m2!1d-74.7549184!2d40.2187745">83
            S. Clinton Avenue Trenton, NJ 08609</a>
        </div>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cart-dash"
            viewBox="0 0 16 16">
            <path d="M6.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z" />
            <path
              d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
          </svg> Levittown is an accessible station.
        </div>
      </div>
      <br />

      <div class="route-details">
        <div class="pr-1 float-left">
          <button class="btn btn-outline-dark " type="submit">Trenton

            <div class="route-selection-status">
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/alert.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </div>
        <strong>
          <button class="btn btn-outline-dark" type="submit">Trenton

            <div class="route-selection-status">
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/alert.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span>
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </strong>
      </div>
      <br />
      <div>

        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Fares
                </button>
              </h2>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="card-body">
                Fare zone:
                Regional Rail Zone NJ
                Ticket Office hours:
                NJ Transit ticket vending machines sell the SEPTA/NJ Transit joint ticket
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Connections
                </button>
              </h2>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
              <div class="card-body">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div>
                        <a href=""><h5>Levittown Station</h5></a> <span class="badge badge-secondary float-right">100 ft</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-outline-dark btn-sm">127</button>&nbsp;
                            <button type="button" class="btn btn-outline-dark btn-sm">128</button>&nbsp;
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div>
                        <a href=""><h5>Levittown Pkwy & Bristol Pike - FS</h5></a> <span class="badge badge-secondary float-right">150 ft</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-outline-dark btn-sm">127</button>&nbsp;
                            <button type="button" class="btn btn-outline-dark btn-sm">128</button>&nbsp;
                        </div>
                    </li>
                  </ul>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingThree">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                  data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Amenities
                </button>
              </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
              <div class="card-body">
                <p>There is free SEPTA parking available at this station.
                    SEPTA Spaces Availability Price
                    Daily 382 FULL FREE
                    Station Amenities
                    4 bike racks are available, accommodating a total of 8 bicycles.</p>
                <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bicycle" viewBox="0 0 16 16">
                    <path d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935.807 1.29a3 3 0 1 1-.848.53l-.508-.812-2.076 3.322A.5.5 0 0 1 8 10.5H5.959a3 3 0 1 1-1.815-3.274L5 5.856V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443-.508.814c.5.444.85 1.054.967 1.743h1.139L5.5 6.943zM8 9.057 9.598 6.5H6.402L8 9.057zM4.937 9.5a1.997 1.997 0 0 0-.487-.877l-.548.877h1.035zM3.603 8.092A2 2 0 1 0 4.937 10.5H3a.5.5 0 0 1-.424-.765l1.027-1.643zm7.947.53a2 2 0 1 0 .848-.53l1.026 1.643a.5.5 0 1 1-.848.53L11.55 8.623z"/>
                  </svg> No bike racks are at this station.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="col-lg-6">
      <span class="badge">Schedule</span>
      <div class="row d-flex p-2 mt-2 text-center">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-today-tab" data-toggle="tab" href="#nav-today" role="tab"
              aria-controls="nav-today" aria-selected="true">
              <span class="badge">
                Today
              </span>
            </a>

            <a class="nav-item nav-link" id="nav-week-tab" data-toggle="tab" href="#nav-week" role="tab"
              aria-controls="nav-week" aria-selected="false">
              <span class="badge">
                Mon-Fri
              </span>
            </a>

            <a class="nav-item nav-link" id="nav-sat-tab" data-toggle="tab" href="#nav-sat" role="tab"
              aria-controls="nav-sat" aria-selected="false">
              <span class="badge">
                Sat
              </span>
            </a>
            <a class="nav-item nav-link" id="nav-sun-tab" data-toggle="tab" href="#nav-sun" role="tab"
              aria-controls="nav-sun" aria-selected="false">
              <span class="badge">
                Sun
              </span>
            </a>
          </div>
        </nav>
      </div>
      <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Route</th>
            <th scope="col">Destination</th>
            <th scope="col">Departure</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row"><a href="/routes/status/TRE">Trenton</a></td>
            <td>Center City Philadelphia</td>
            <td><a href="/schedule/trip/20211007_TRE_720_V51_M">4:07 pm</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-main-footer></app-main-footer>
